import  React, { useEffect, useState } from 'react';
import Floral from '../assets/image/floral7.png';

const calculateTimeLeft = () => {
    
    let DateTime = new Date();
    let year = DateTime.getFullYear();
    const difference = +new Date(`11/14/${year}`) - +new Date();
    let timeLeft = {};
    if (difference > 0) {
        timeLeft = {
            hari: Math.floor(difference / (1000 * 60 * 60 * 24)),
            jam: Math.floor((difference / (1000 * 60 * 60)) % 24),
            menit: Math.floor((difference / 1000 / 60) % 60),
            detik: Math.floor((difference / 1000) % 60)
        };
        return timeLeft;
    }
}

const DateWedding = () => {

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearTimeout(timer);
    });

    const timerComponents = [];
    console.log(timeLeft);
    if (timeLeft !== undefined) {
        Object.keys(timeLeft).forEach((interval, index) => {
            if (!timeLeft[interval]) {
                return;
            }
            // console.log(interval);
            timerComponents.push(
                <div key={index} className="bg-white font-poppins rounded-md px-6 py-5 lg:px-10 lg:py-6 mr-4 lg:mr-8">
                    <div className="text-center text-gray-wed font-semibold text-md lg:mb-2 lg:mt-2 lg:text-2xl">
                        {timeLeft[interval]}
                    </div>
                    <div className="text-gray-darkest text-xs sm:text-xs lg:text-sm text-center font-poppins font-semibold uppercase">
                        {interval}
                    </div>
                </div>
            );
        });
    }

    return(
        <div id="date" className="bg-gray-wedlist">
            <div className="pt-28 mb-20">
                <div className="text-center mb-8">
                    <div className="text-base text-5xl font-Alexs text-white">
                    14 November 2021
                    </div>
                    <div className="text-white text-md mt-3 font-poppins uppercase">
                        Suralaga, lombok timur
                    </div>
                </div>
                <div className="flex justify-center">
                    {/* <div className="bg-white font-poppins rounded-md px-10 py-8 mr-4 lg:mr-8">
                        <div className="text-center font-semibold mb-2 mt-2 text-2xl">
                            200
                        </div>
                        <di className="text-gray-darkes text-center font-poppins font-semibold uppercase">
                            hours
                        </di>
                    </div>
                    <div className="bg-white font-poppins rounded-md px-10 py-8 mr-4 lg:mr-8">
                        <div className="text-center font-semibold mb-2 mt-2 text-2xl">
                            12
                        </div>
                        <di className="text-gray-darkes text-center font-poppins font-semibold uppercase">
                            MINS
                        </di>
                    </div>
                    <div className="bg-white font-poppins rounded-md px-10 py-8">
                        <div className="text-center font-semibold mb-2 mt-2 text-2xl">
                            21
                        </div>
                        <di className="text-gray-darkes text-center font-poppins font-semibold uppercase">
                            SECS
                        </di>
                    </div> */}
                    {timerComponents.length ? timerComponents : <span className="text-lg font-Alexs text-white">sedang berlangsung</span>}
                </div>
            </div>
            <div className="flex justify-center">
                <img className="-mb-24 lg:-mb-22 lg:w-5/12 lg:h-60 md:h-60 h-48" alt="..." src={Floral}></img>
            </div>
        </div>
    );
};

export default DateWedding;